"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var PropTypes = _interopRequireWildcard(require("prop-types"));

var _reactIntersectionObserver = require("react-intersection-observer");

var _lodash = require("lodash");

var _Term = _interopRequireDefault(require("../../../../utilities/transcriptLib/Term"));

var _Word = _interopRequireDefault(require("./Word"));

var _components = _interopRequireDefault(require("../../../../styles/components"));

var _connectToMedia = _interopRequireDefault(require("../../../Media/connectToMedia"));

var _ScrollerContext = _interopRequireDefault(require("../../../ScrollerContext"));

var _index = require("../../../../assets/icons/index");

var _moment = _interopRequireDefault(require("moment"));

var _deepEqual = _interopRequireDefault(require("deep-equal"));

var _connectToScroller = _interopRequireDefault(require("../connectToScroller"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TIME_PADDING = 60 * 1000;
/**
 * A margin around the current turn's extend for which .
 * a turn element is considered "current" and will therefor render fully.
 */

function stampToTime(time) {
  if (!(time && (0, _lodash.isNumber)(time))) {
    return time || "00:00";
  }

  var newTime = new Date(time || 0); // still need this in case ms = NaN

  var isHourTimeLabel = newTime.getUTCHours() >= 1;
  return newTime.toISOString().slice(isHourTimeLabel ? 11 : 14, -5);
}
/**
 * a "Turn" represents a line of conversation by a single speaker.
 * Has one or more sentences.
 * Note -- turns do NOT NECESSARILY alternate. In circumstances where
 * a single speaker goes on for some time their sentences may be chunked
 * into sequential turns. (for instance for a single speaker.
 */


var Turn = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Turn, _Component);

  function Turn() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      frameRef: false,
      inView: false
    });

    return _this;
  }

  var _proto = Turn.prototype;

  /**
   * whether the currentTime is contained in the turn's start/end range.
   * note - not STRITCLY accurate as some margin (TIME_PADDING) is added to be generous.
   *
   *
   * @param props
   * @returns {boolean}
   */
  _proto.containsCurrentTime = function containsCurrentTime(props) {
    // even things out of view are fully rendered in a time window.
    if (!props) {
      props = this.props;
    }

    if (!props) return false;
    var _props = props,
        turn = _props.turn,
        currentTime = _props.currentTime;

    if (!((0, _lodash.isNumber)(currentTime) && turn)) {
      return false;
    }

    turn === null || turn === void 0 ? void 0 : turn.freezeRange(); // memoize the turn's time ranges.

    var start = turn.start,
        end = turn.end;
    var i = (0, _lodash.clamp)(currentTime, start - TIME_PADDING, end + TIME_PADDING) === currentTime;
    return i;
  };

  _proto.isFullRender = function isFullRender() {
    return (0, _lodash.get)(this, "state.inView") || this.containsCurrentTime();
  };

  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
    if (!(0, _deepEqual["default"])(nextProps.media, this.props.media)) return true;

    if (!(0, _deepEqual["default"])(nextProps.query, this.props.query)) {
      return true;
    }

    return (0, _lodash.get)(this, "state.inView") !== (0, _lodash.get)(nextState, "inView") || this.containsCurrentTime(nextProps) !== this.containsCurrentTime();
  };

  _proto.syncFrame = function syncFrame(e) {
    if (this.state.frameRef !== e) {
      this.setState({
        frameRef: e
      });
    }
  };

  _proto.componentDidMount = function componentDidMount() {
    var e = (0, _lodash.get)(this.context, "current");
    this.syncFrame(e);
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    var e = (0, _lodash.get)(this.context, "current");
    this.syncFrame(e);
  };

  _proto.getTranscriptText = function getTranscriptText(fullRender) {
    var _this$props = this.props,
        turn = _this$props.turn,
        onSeek = _this$props.onSeek,
        isChatTextMedia = _this$props.isChatTextMedia;
    turn === null || turn === void 0 ? void 0 : turn.freezeWords();
    var phrases; // fully formatted word divs

    phrases = turn === null || turn === void 0 ? void 0 : turn.value.filter(function (a) {
      return a;
    }).map(function (sentence) {
      var _sentence$value;

      var sentenceWords = sentence === null || sentence === void 0 ? void 0 : (_sentence$value = sentence.value) === null || _sentence$value === void 0 ? void 0 : _sentence$value.filter(function (t) {
        return t instanceof _Term["default"];
      });
      return /*#__PURE__*/_react["default"].createElement(_components["default"].SentenceMarker, {
        key: sentence.id
      }, sentenceWords === null || sentenceWords === void 0 ? void 0 : sentenceWords.map(function (word, idx) {
        var wordSpaceBuilder = function wordSpaceBuilder() {
          // If current "word" is an ending punctuation mark (".", "?", "!"), add trailing space
          var isEndingPunc = word.isMeta && word.meta === "punc" && /([?!.])$/.test(word.value);

          if (isEndingPunc) {
            return word.value + " ";
          } // Check to see if previous "word" is other type of punctuation or open bracket/parenthesis.


          var prevWord = sentenceWords === null || sentenceWords === void 0 ? void 0 : sentenceWords[idx - 1];
          var isPrevWordPunc = prevWord && /([#'‘$@[{(/_.?!=-])$/.test(prevWord.value); // Check is see if current "word" begins with alphanumeric char

          var isAlphaNumericWord = /(^[a-zA-Z0-9])/.test(word.value);
          var isOpeningPuncWord = /(^[*‘“#&$[({])/.test(word.value);
          return "" + ((isAlphaNumericWord && !isPrevWordPunc || isOpeningPuncWord) && idx !== 0 ? " " : "") + word.value;
        };

        return /*#__PURE__*/_react["default"].createElement(_Word["default"], {
          key: word.id,
          isMeta: word.isMeta,
          meta: word.meta,
          value: wordSpaceBuilder(),
          className: word.getClasses("word"),
          onClick: function onClick() {
            return onSeek({
              s: word.start,
              p: word.p
            });
          }
        });
      }));
    });
    return phrases;
  };

  _proto.setSpeakerIcon = function setSpeakerIcon(turn) {
    var _this$props2, _get;

    switch (((_this$props2 = this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.isChatTextMedia) ? (_get = (0, _lodash.get)(turn, "speaker")) === null || _get === void 0 ? void 0 : _get.toLowerCase() : turn === null || turn === void 0 ? void 0 : turn.get("speaker").toLowerCase()) {
      case "agent":
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "speaker-icon agent-icon-bk"
        }, /*#__PURE__*/_react["default"].createElement(_index.AgentIcon, null));

      case "bot":
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "speaker-icon bot-icon-bk"
        }, /*#__PURE__*/_react["default"].createElement(_index.BotIcon, null));

      case "system":
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "speaker-icon system-icon-bk"
        }, /*#__PURE__*/_react["default"].createElement(_index.SystemIcon, null));

      default:
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "speaker-icon customer-icon-bk"
        }, /*#__PURE__*/_react["default"].createElement(_index.CustomerIcon, null));
    }
  };

  _proto.getMessageTimestamp = function getMessageTimestamp() {
    var _metadata$detail, _metadata$detail$call, _metadata$callDetails;

    // callStartTime is written in ISO8601 format, convert to Unix time
    // in order to add Turn start times (milliseconds)
    // to get a timestamp for each Turn. Timestamps returned in UTC time
    var _this$props3 = this.props,
        turn = _this$props3.turn,
        _this$props3$isChatTe = _this$props3.isChatTextMedia,
        isChatTextMedia = _this$props3$isChatTe === void 0 ? false : _this$props3$isChatTe,
        _this$props3$metadata = _this$props3.metadata,
        metadata = _this$props3$metadata === void 0 ? {} : _this$props3$metadata;

    if (!isChatTextMedia) {
      return "";
    }

    var callStartTime = (metadata === null || metadata === void 0 ? void 0 : (_metadata$detail = metadata.detail) === null || _metadata$detail === void 0 ? void 0 : (_metadata$detail$call = _metadata$detail.callDetails) === null || _metadata$detail$call === void 0 ? void 0 : _metadata$detail$call.callStartTime) || (metadata === null || metadata === void 0 ? void 0 : (_metadata$callDetails = metadata.callDetails) === null || _metadata$callDetails === void 0 ? void 0 : _metadata$callDetails.callStartTime);
    var callStartUnixTime = callStartTime ? new Date(callStartTime).getTime() : 0;
    return callStartUnixTime ? " \u2014 " + _moment["default"].utc(new Date(callStartUnixTime + ((turn === null || turn === void 0 ? void 0 : turn.start) || (turn === null || turn === void 0 ? void 0 : turn.s)))).format("MMM DD, YYYY H:mm:ss A") + " UTC" : "";
  };

  _proto.highlightSelectedKeywordTurn = function highlightSelectedKeywordTurn() {
    var _this$props4, _this$props4$query;

    var _this$props$turn = this.props.turn,
        turn = _this$props$turn === void 0 ? {} : _this$props$turn;
    var hasKeywordQuery = (_this$props4 = this.props) === null || _this$props4 === void 0 ? void 0 : (_this$props4$query = _this$props4.query) === null || _this$props4$query === void 0 ? void 0 : _this$props4$query.some(function (query) {
      return query.type === "keywords";
    });
    var keywordQueryExistsInTurn = false;

    if (hasKeywordQuery) {
      var _this$props5;

      var queryTimes = (0, _lodash.flatten)((_this$props5 = this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.query.filter(function (query) {
        return query.type === "keywords";
      }).map(function (query) {
        return query.hits.map(function (hit) {
          return hit.s;
        });
      }));
      keywordQueryExistsInTurn = queryTimes.some(function (query) {
        return query >= turn.s && query <= turn.e;
      });
    }

    return keywordQueryExistsInTurn;
  };

  _proto.containsText = function containsText(w, searchedWord, words, index) {
    var searchedWordArr = searchedWord.trim().replace(/[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]/g, "").split(" ");

    if (searchedWordArr.length > 1) {
      var firstMatch = searchedWordArr.shift();

      if (w.toLowerCase().includes(firstMatch.toLowerCase())) {
        var nextString = [];

        for (var i = 1; i <= searchedWordArr.length; i++) {
          if (words[index + i]) {
            nextString.push(words[index + i].replace(/<\/?[^>]+(>|$)/g, "").replace(/[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]/g, "").toLowerCase());
          }
        }

        return searchedWordArr.length === nextString.length && searchedWordArr.join(" ").toLowerCase().trim() === nextString.join(" ");
      }
    }

    return w.replace(/[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]/g, "").toLowerCase() === searchedWord.replace(/[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]/g, "").trim().toLowerCase();
  };

  _proto.highlightSearchedWordInTurn = function highlightSearchedWordInTurn() {
    var _this$props6,
        _this$props6$query,
        _this2 = this;

    var _this$props$turn2 = this.props.turn,
        turn = _this$props$turn2 === void 0 ? {} : _this$props$turn2;
    var hasSearchKeyword = (_this$props6 = this.props) === null || _this$props6 === void 0 ? void 0 : (_this$props6$query = _this$props6.query) === null || _this$props6$query === void 0 ? void 0 : _this$props6$query.some(function (query) {
      return query.type === "search";
    });

    if (hasSearchKeyword) {
      var _this$props7;

      var queryTimes = (_this$props7 = this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.query.filter(function (query) {
        return query.type === "search";
      }).map(function (query) {
        return {
          label: query.label,
          hit: query.hits
        };
      });

      if (queryTimes.length && queryTimes.every(function (val) {
        return val.hit.length > 0;
      })) {
        var words = turn.text.split(" ");
        queryTimes.forEach(function (query) {
          var searchedWord = query.label;
          var regex = new RegExp("" + searchedWord, "g");
          var matches = [].concat(turn.text.matchAll(regex));
          var hitIndex = 0;
          var hit = query.hit.filter(function (hit) {
            return hit.s >= turn.s && hit.s <= turn.e;
          });

          if (!hit.length) {
            query.hit.filter(function (val) {
              return val.p === parseInt(document.getElementById("chat-frame-value").value);
            });
          }

          words.forEach(function (w, i) {
            var _hit$hitIndex;

            if (hit.length && _this2.containsText(w, searchedWord, words, i) && ((_hit$hitIndex = hit[hitIndex]) === null || _hit$hitIndex === void 0 ? void 0 : _hit$hitIndex.p)) {
              var _hit$hitIndex5;

              if (i - 1 >= 0 && words[i - 1]) {
                var _hit$hitIndex2;

                words[i - 1] = "<span class='word-index-" + (((_hit$hitIndex2 = hit[hitIndex]) === null || _hit$hitIndex2 === void 0 ? void 0 : _hit$hitIndex2.p) - 1) + "'>" + words[i - 1] + "</span>";
              }

              if (i - 2 >= 0 && words[i - 2]) {
                var _hit$hitIndex3;

                words[i - 2] = "<span class='word-index-" + (((_hit$hitIndex3 = hit[hitIndex]) === null || _hit$hitIndex3 === void 0 ? void 0 : _hit$hitIndex3.p) - 2) + "'>" + words[i - 2] + "</span>";
              }

              var searchedWordArr = searchedWord.trim().split(" ");

              for (var j = 1; j <= searchedWordArr.length + 2; j++) {
                if (i + j <= words.length - 1 && words[i + j]) {
                  var _hit$hitIndex4;

                  words[i + j] = "<span class='word-index-" + (((_hit$hitIndex4 = hit[hitIndex]) === null || _hit$hitIndex4 === void 0 ? void 0 : _hit$hitIndex4.p) + j) + "'>" + words[i + j] + "</span>";
                }
              }

              words[i] = "<span class=' word-index-" + ((_hit$hitIndex5 = hit[hitIndex]) === null || _hit$hitIndex5 === void 0 ? void 0 : _hit$hitIndex5.p) + "'>" + w + "</span>";
              hitIndex += 1;
            }
          });
        });
        return words.join(" ");
      }
    }

    return turn.text;
  };

  _proto.render = function render() {
    var _this3 = this;

    var _this$props8 = this.props,
        _this$props8$turn = _this$props8.turn,
        turn = _this$props8$turn === void 0 ? {} : _this$props8$turn,
        speakerColors = _this$props8.speakerColors,
        onSeek = _this$props8.onSeek,
        isChatTextMedia = _this$props8.isChatTextMedia,
        media = _this$props8.media,
        query = _this$props8.query,
        turnIndex = _this$props8.turnIndex,
        currentTime = _this$props8.currentTime,
        currentPosition = _this$props8.currentPosition;
    var ref = (0, _lodash.get)(this, "context.scrollRef");
    var fullRender = this.isFullRender();
    var turnContentContainer = document.getElementById("chat-turn-content-" + turnIndex);

    if (turnContentContainer) {
      turnContentContainer.innerHTML = this.highlightSearchedWordInTurn();
    }

    return /*#__PURE__*/_react["default"].createElement(_reactIntersectionObserver.InView, {
      as: "div",
      ref: ref,
      onChange: function onChange(inView) {
        if ((0, _lodash.get)(_this3, "state.inView") !== inView) {
          _this3.setState({
            inView: inView
          });
        }
      }
    }, /*#__PURE__*/_react["default"].createElement(_components["default"].TranscriptTurn, {
      className: (isChatTextMedia ? this.highlightSelectedKeywordTurn() ? "chat-turn-range-true" : "" : turn === null || turn === void 0 ? void 0 : turn.getClasses("turn")) + " " + (isChatTextMedia && (media === null || media === void 0 ? void 0 : media.currentTime) >= turn.s && (media === null || media === void 0 ? void 0 : media.currentTime) <= turn.e ? "chat-turn-time-scroll-true" : "")
    }, /*#__PURE__*/_react["default"].createElement(_components["default"].TurnBody, null, /*#__PURE__*/_react["default"].createElement(_components["default"].TurnLabels, {
      style: {
        display: "flex",
        alignItems: "Center"
      }
    }, /*#__PURE__*/_react["default"].createElement(_components["default"].TurnSpeakerIcon, null, this.setSpeakerIcon(turn)), /*#__PURE__*/_react["default"].createElement("div", {
      className: "turn-labels-speaker-time"
    }, /*#__PURE__*/_react["default"].createElement(_components["default"].TurnSpeaker, {
      // color={speakerColors.get(turn.get('speaker'))}
      color: "#262D38"
    }, isChatTextMedia ? (0, _lodash.get)(turn, "speaker") || (0, _lodash.get)(turn, "speakerName") : turn === null || turn === void 0 ? void 0 : turn.get("speaker")), /*#__PURE__*/_react["default"].createElement(_components["default"].TurnTime, null, /*#__PURE__*/_react["default"].createElement(_components["default"].TimeLink, {
      onClick: function onClick() {
        return onSeek({
          s: turn === null || turn === void 0 ? void 0 : turn.start,
          p: turn === null || turn === void 0 ? void 0 : turn._words[0].p
        });
      },
      style: {
        color: "rgba(38, 45, 56, 0.5)"
      }
    }, (turn === null || turn === void 0 ? void 0 : turn.createTime) ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, _moment["default"].utc(new Date(turn.createTime)).format("MMM DD, YYYY H:mm:ss A") + " UTC") : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, stampToTime((turn === null || turn === void 0 ? void 0 : turn.start) || (turn === null || turn === void 0 ? void 0 : turn.s)), this.getMessageTimestamp())))))), /*#__PURE__*/_react["default"].createElement(_components["default"].TurnBody, null, /*#__PURE__*/_react["default"].createElement("div", null, isChatTextMedia ? /*#__PURE__*/_react["default"].createElement(_components["default"].SentenceMarker, {
      id: "chat-turn-content-" + turnIndex,
      className: (this.highlightSelectedKeywordTurn() ? "chat-turn-highlighted" : "") + " "
    }) : this.getTranscriptText(fullRender)))));
  };

  return Turn;
}(_react.Component);

_defineProperty(Turn, "contextType", _ScrollerContext["default"]);

Turn.propTypes = process.env.NODE_ENV !== "production" ? {
  turn: PropTypes.any,
  currentTime: PropTypes.number,
  speakers: PropTypes.array,
  speakerColors: PropTypes.any,
  onSeek: PropTypes.func
} : {};

var _default = (0, _connectToMedia["default"])(function (state) {
  return (0, _lodash.pick)(state, ["media", "currentTime", "currentPosition", "query"]);
})(Turn);

exports["default"] = _default;